import * as z from "zod";

import { issueSchema } from "./issue";
import { userSchema } from "./user";

export const issueWithCreatedBySchema = issueSchema.extend({
  createdBy: userSchema,
});

export type IssueWithCreatedBy = z.infer<typeof issueWithCreatedBySchema>;
